import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { createFileRoute } from '@tanstack/react-router'
import { WebhookVerificationPage } from 'features/webhooks'
import { canEditConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/verify')({
  component: WebhookVerificationPage,
  beforeLoad: (ctx) => protectWithWorkspacePermissions(canEditConfigurationPermission)(ctx),
})
